import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import type { SpeciesInterface } from '../models/species.interface';

@Injectable({
  providedIn: 'root'
})
export class SpeciesService {
  constructor(private readonly apollo: Apollo) { }

  getSpecies(): Observable<SpeciesInterface[]> {
    return this.apollo.query<{ species: SpeciesInterface[] }>({
      query : gql`query species {
        species {
          id
          name
        }
      }`
    }).pipe(map(result => result.data.species));
  }
}
